import ReplyQuote from './ReplyQuote';

export default ReplyQuote;

